import { useSustainabilityApi } from '@/hooks'
import { formatNumber } from '@/utils/formatValueWithUnit'
import { useMemo } from 'react'
import { EmissionTotalCard } from '../EmissionTotalCard/EmissionTotalCard'

const EMISSIONS_DISPLAY_LABEL_MAP = {
    CO2: 'CO₂',
    CH4: 'CH₄',
    N2O: 'N₂O',
}

const EMISSIONS_DISPLAY_UOM_MAP = {
    CO2eMT: 'Mt',
    MT: 'Mt',
}

type GHGEmissionsTotalsCardContainerProps = {
    title: string
    params: Parameters<
        ReturnType<typeof useSustainabilityApi>['useTotalEmissionsQuery']
    >[0]
}

export const GHGEmissionsTotalsCardContainer: React.FC<
    GHGEmissionsTotalsCardContainerProps
> = ({ title, params }) => {
    const { useTotalEmissionsQuery } = useSustainabilityApi()
    const { data, isLoading, isError } = useTotalEmissionsQuery({
        ...params,
        uom: 'MT',
    })

    const processedData = useMemo(() => {
        if (!data) return []

        return [
            ...data.items.map((item) => ({
                ...item,
                name:
                    EMISSIONS_DISPLAY_LABEL_MAP[
                        item.name as keyof typeof EMISSIONS_DISPLAY_LABEL_MAP
                    ] || item.name,
                value: formatNumber(item.value),
                uom:
                    EMISSIONS_DISPLAY_UOM_MAP[
                        item.uom as keyof typeof EMISSIONS_DISPLAY_UOM_MAP
                    ] || item.uom,
            })),
            {
                name: 'CO₂e',
                value: formatNumber(data.total),
                uom: EMISSIONS_DISPLAY_UOM_MAP['CO2eMT'],
            },
        ]
    }, [data])

    return (
        <div className="rounded-lg border border-neutral-200 px-4 py-3 shadow-sm">
            <EmissionTotalCard
                title={title}
                data={processedData}
                isLoading={isLoading}
                isError={isError}
            />
        </div>
    )
}
